<template>
  <div class="empty">
    <img class="image" src="@/images/empty/good.png" />
    <div class="desc">
      <p class="content">没有更多同类商品了</p>
      <p class="content">您一下就挑中了～</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyLayout',
  methods: {}
}
</script>

<style lang="scss" scoped>
.empty {
  display: flex;

  height: 2.8rem;
  margin-top: 0.24rem;
  padding: 0 1.6rem;

  background-color: #fff;

  border-radius: 0.16rem;

  justify-content: space-between;
  align-items: center;

  .image {
    display: block;

    width: 1.2rem;
  }

  .desc {
    font-size: 0.28rem;
    line-height: 0.28rem;
    @include text-overflow-ellipsis-single;
    .content {
      line-height: 0.32rem;
      color: #999;
    }
    .content + .content {
      margin-top: 0.08rem;
    }
  }
}
</style>
